module.exports = __webpack_public_path__ + "img/product-program-ykp-icon2.4fb1ee79.png";